import { gql } from "@apollo/client";

export const DRUG_POPUP = gql`
  query Drug($drugId: ID!) {
    drug(id: $drugId) {
      id
      name
      genericName: ingredient
      isBiologic
      mechanismsOfAction {
        id
        name
      }
      tearSheets {
        tearSheetIndications: indications {
          diseaseState {
            id
            name
            rxStrategies {
              url
            }
          }
          id
          indication {
            id
            name
          }
          status {
            stage
          }
        }
        therapeuticAreaTags {
          id
          name
        }
        url
      }
      url
    }
  }
`;
